import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import KlagerapportFilterForm from "./KlagerapportFilterForm";
import { INITIAL_STATE as klagerapportFilterFormInitState } from "../../../reducers/forms/KlageRapportFilterFormReducer";
import { getSelectOptionsEnhanced } from "../../../selectors/selectOptionsSelector";

import { getIleggelsestyper } from "../../../actions/ileggelsestyperActions";
import {
  handleChange as handleChangeAction,
  handleChangeToInitState as handleChangeToInitStateAction,
} from "../../../actions/handleChangeAction";

import {
  getKlageLedelseRapport,
  ResetKlageLedelseRapport,
} from "../../../actions/klager/klageAction";

import * as inputValidation from "../../../utils/inputValidationUtils";

const defaultSortOptions = [
  { id: "antallGebyrer_asc", navn: "Antall gebyr lav-høy" },
  { id: "antallGebyrer_desc", navn: "Antall gebyr høy-lav" },
  { id: "antallKlageSaker_asc", navn: "Antall sak lav-høy" },
  { id: "antallKlageSaker_desc", navn: "Antall sak høy-lav" },
];

function KlageRapporterFilterContainer({
  updateSelectedIleggelsestyperState,
  sortOptions = defaultSortOptions,
}) {
  const dispatch = useDispatch();
  const klageRapportFilterFormState = useSelector(
    (state) => state.forms.klageRapportFilterForm,
  );
  const ileggelsestyper = useSelector((state) =>
    getSelectOptionsEnhanced(state, "ileggelsestyper", "navn", "id"),
  );

  const [showSokSpinner, setShowSokSpinner] = useState(false);
  const [showTilbakestillSpinner, setShowTilbakestillSpinner] = useState(false); // eslint-disable-line no-unused-vars
  const [
    ShallGetklagerapportDueToHandleChangeToInitState,
    setShallGetklagerapportDueToHandleChangeToInitState,
  ] = useState(false);
  const axiosCancelTokenSource = useRef(null);

  useEffect(() => {
    dispatch(getIleggelsestyper());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      JSON.stringify(klageRapportFilterFormState) ===
        JSON.stringify(klagerapportFilterFormInitState) &&
      ShallGetklagerapportDueToHandleChangeToInitState === true
    ) {
      setShallGetklagerapportDueToHandleChangeToInitState(false);
      setShowTilbakestillSpinner(true);
      axiosCancelTokenSource.current = axios.CancelToken.source();
    }
  });

  useEffect(() => {
    return () => {
      axiosCancelTokenSource.current && axiosCancelTokenSource.current.cancel();
    };
  }, []);

  const handleChange = (e) => {
    dispatch(
      handleChangeAction(
        "KLAGERAPPORT_FILTER_FORM",
        e.target.name,
        e.target.value,
      ),
    );
  };

  const handleChangeToInitState = () => {
    dispatch(handleChangeToInitStateAction("KLAGERAPPORT_FILTER_FORM"));
    dispatch(ResetKlageLedelseRapport());
    setShallGetklagerapportDueToHandleChangeToInitState(true);
  };

  const resetValidationErrorText = () => {
    dispatch(
      handleChangeAction(
        "KLAGERAPPORT_FILTER_FORM",
        "fraDatoValidationErrorText",
        null,
      ),
    );
    dispatch(
      handleChangeAction(
        "KLAGERAPPORT_FILTER_FORM",
        "tilDatoValidationErrorText",
        null,
      ),
    );
  };

  const validate = () => {
    return inputValidation.fraDateTimeTilDateTimeValidation(
      klageRapportFilterFormState,
      (name, value) =>
        dispatch(handleChangeAction("KLAGERAPPORT_FILTER_FORM", name, value)),
    );
  };

  const getFilters = () => {
    const { fraDato, tilDato, selectedIleggelsestyper } =
      klageRapportFilterFormState;
    const selectIleggelsetyper = selectedIleggelsestyper.map((x) => x.id);
    return {
      fraDato: fraDato && fraDato.toISOString(),
      tilDato: tilDato && tilDato.toISOString(),
      ileggelsestype: selectIleggelsetyper,
      navn: "ledelse_statistikk",
    };
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    resetValidationErrorText();
    if (validate()) {
      const selectedIleggelsestyper =
        klageRapportFilterFormState.selectedIleggelsestyper &&
        klageRapportFilterFormState.selectedIleggelsestyper.map(
          (sit) => sit.navn,
        );
      updateSelectedIleggelsestyperState(selectedIleggelsestyper);
      setShowSokSpinner(true);
      const params = getFilters();
      dispatch(getKlageLedelseRapport(params))
        .then(() => setShowSokSpinner(false))
        .catch(() => setShowSokSpinner(false));
    }
  };

  return (
    <KlagerapportFilterForm
      showSokSpinner={showSokSpinner}
      klageRapportFilterFormState={klageRapportFilterFormState}
      handleChange={handleChange}
      handleChangeToInitState={handleChangeToInitState}
      handleSubmit={handleSubmit}
      ileggelsestyper={ileggelsestyper}
      sortOptions={sortOptions}
    />
  );
}

export default KlageRapporterFilterContainer;
